import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { setSelectedUserOpt } from '../store/actions/commonActions';

class SelectUserField extends Component {

  render() {
    let fieldName = this.props.fieldName;
    let users = this.props.users;
    let defaultValue = this.props.defaultValue;
    let multiple =  this.props.multiple;
    let selectOnce = this.props.selectOnce;
    let onChangeCallback = this.props.onChangeCallback;

    let usersOptions = [];
    let currentValues = ''; 
    let defaultValueIndex = null;
    let selectField = '';

    if (users) {
      usersOptions = users.length > 0 && users.map((user) => {
        return {
          label: user.first_name + " " + user.last_name, 
          value: user.id
        }
      })
    }

    if (defaultValue && typeof(defaultValue) === "object" && !defaultValue.length) {
      defaultValue = null;
    }

    if ((defaultValue !== 0 
      && defaultValue !== "" && defaultValue)) {
      //get default value
      if (typeof(usersOptions) === 'object') {
        //is array, multiple values
        if (defaultValue === 'object') {
          currentValues = [];
          usersOptions.forEach((userOpt, index) => {
            if (defaultValue.includes(userOpt.value)) {
              currentValues.push(usersOptions[index]);
            }
          })
        }
        else {
          usersOptions.forEach((userOpt, index) => {
            if (userOpt.value === defaultValue) {
              defaultValueIndex = index;
            }
          })

          currentValues = usersOptions[defaultValueIndex];
        }
      }
    }
    //make sure options are available first to display the field with default value
    if (usersOptions.length > 0) {
      if (selectOnce) {
        selectField = <Select
                        isSearchable={true}
                        name={fieldName} 
                        defaultValue={currentValues} 
                        isMulti={multiple} 
                        value={this.props.common.selectedUserOption} 
                        options={usersOptions} 
                        onChange={(values) => {
                          this.props.setSelectedUserOpt(values);
                          onChangeCallback(values)
                        }}
                      />
      }
      else {
        selectField = <Select
                        isSearchable={true}
                        name={fieldName} 
                        value={currentValues} 
                        isMulti={multiple} 
                        options={usersOptions} 
                        onChange={(values) => onChangeCallback(values)}
                      />
      }
    }
    else {
      selectField = <Select
                        isSearchable={true}
                        name={fieldName} 
                        isMulti={multiple} 
                        options={usersOptions} 
                        onChange={(values) => onChangeCallback(values)}
                      />
    }
    
    return (
      selectField
    )
  }
}

const mapStateToProps = (state) => ({
  common: state.common 
})

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedUserOpt: (...args) => dispatch(setSelectedUserOpt(...args))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectUserField)
